<div data-cy="course-list">
  @if (filteredCourses().length > 0) {
    <div class="table-container">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>
              <app-sortable-header column="name" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                Name
              </app-sortable-header>
            </th>
            <th>
              <app-sortable-header column="shortName" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                Short Name
              </app-sortable-header>
            </th>
            <th>
              <app-sortable-header column="tournamentName" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                Tournament
              </app-sortable-header>
            </th>
            <th>
              <app-sortable-header column="createdOnUtc" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                Created
              </app-sortable-header>
            </th>
            <th>
              <app-sortable-header column="modifiedOnUtc" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                Modified
              </app-sortable-header>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (course of paginationResult().items; track course; let i = $index) {
            <tr data-cy="course-row">
              <td>
                <a [routerLink]="getCourseLink(course.courseId)" class="course-name-link">
                  {{ course.name }}
                </a>
              </td>
              <td>{{ course.shortName }}</td>
              <td>
                @if (course.tournamentId) {
                  <a [routerLink]="'/tournaments/' + course.tournamentId">
                    {{ course.tournamentName }}
                  </a>
                }
                @if (!course.tournamentId) {
                  <span>{{ course.tournamentName }}</span>
                }
              </td>
              <td>{{ course.createdOnUtc | date:'short' }}</td>
              <td>{{ course.modifiedOnUtc | date:'short' }}</td>
            </tr>
          }
        </tbody>
      </table>
      <!-- Pagination Component -->
      <app-table-pagination [paginationData]="paginationResult()" [itemDescriptor]="'Courses'"
        (pageChange)="onPageChange($event)">
      </app-table-pagination>
    </div>
  }

  @if (filteredCourses().length === 0 && courses().length === 0) {
    <div class="alert alert-info">
      <i class="fa fa-info-circle"></i> No courses found.
    </div>
  } @else if (filteredCourses().length === 0 && courses().length > 0) {
    <div class="alert alert-warning" data-cy="no-courses-message">
      <i class="fa fa-exclamation-triangle"></i> No courses match your search criteria.
    </div>
  }
</div>